// Actions
const HANDLE_LOGIN_RENDER = 'zen/login/HANDLE_LOGIN_RENDER';
const HANDLE_LOGIN = 'zen/login/HANDLE_LOGIN';
const HANDLE_OKTA_LOGIN = 'zen/login/HANDLE_OKTA_LOGIN';
const HANDLE_OKTA_LOGIN_FAIL = 'zen/login/HANDLE_OKTA_LOGIN_FAIL';
const HANDLE_LOGIN_SUCCESS = 'zen/login/HANDLE_SUCCESS';
const HANDLE_LOGIN_FAIL = 'zen/login/HANDLE_FAIL';
const HANDLE_LOGIN_INPUT_CHANGE = 'zen/login/HANDLE_INPUT_CHANGE';
const HANDLE_LOGIN_FORGOT_CREDENTIALS = 'zen/login/HANDLE_FORGOT_CREDENTIALS';
const HANDLE_MODAL_CLOSE = 'zen/login/HANDLE_MODAL_CLOSE';

const initialState = {
  isLoggedIn: false,
  isModalOpen: false,
  fetching: false,
  errorMessage: '',
  notificationMessage: '',
  legacyLoginFormWithOkta:false
};

// Reducer
const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case HANDLE_LOGIN:
      return Object.assign({}, state, {
        isLoggedIn: false,
        fetching: true,
        errorMessage: ''
      });
    case HANDLE_OKTA_LOGIN:
      return Object.assign({}, state, {
        isLoggedIn: false,
        fetching: true,
        errorMessage: ''
      });
    case HANDLE_OKTA_LOGIN_FAIL:
      return Object.assign({}, state, {
        isLoggedIn: false,
        fetching: false,
        errorMessage: action.payload
      });
    case HANDLE_LOGIN_FORGOT_CREDENTIALS:
      return Object.assign({}, state, {
        isModalOpen: true
      });
    case HANDLE_LOGIN_INPUT_CHANGE:
      return Object.assign({}, state, {
        errorMessage: ''
      });
    case HANDLE_MODAL_CLOSE:
      return Object.assign({}, state, {
        isModalOpen: false
      });
    case HANDLE_LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isLoggedIn: true,
        fetching: false,
        errorMessage: ''
      });
    case HANDLE_LOGIN_FAIL:
      return Object.assign({}, state, {
        isLoggedIn: false,
        fetching: false,
        errorMessage: 'Username and password combination invalid. Please try again.'
      });
    case HANDLE_LOGIN_RENDER:
      return {
        ...state,
        legacyLoginFormWithOkta:action.payload
      };
    default: return state;
  }
};

// Action Creators
const handleLogin = (payload) => {
  return { type: HANDLE_LOGIN, payload };
};

const handleOktaLogin = (payload) => {
  return { type: HANDLE_OKTA_LOGIN, payload };
};

const handleOktaLoginFailure = (payload) => {
  return { type: HANDLE_OKTA_LOGIN_FAIL, payload };
};

const handleLoginSuccess = (payload) => {
  return { type: HANDLE_LOGIN_SUCCESS, payload };
};

const handleLoginFail = (payload) => {
  return { type: HANDLE_LOGIN_FAIL, payload };
};

const handleLoginInputChange = (payload) => {
  return { type: HANDLE_LOGIN_INPUT_CHANGE, payload };
};

const handleLoginForgotCredentials = (payload) => {
  return { type: HANDLE_LOGIN_FORGOT_CREDENTIALS, payload };
};

const handleModalClose = (payload) => {
  return { type: HANDLE_MODAL_CLOSE, payload };
};

const handleLoginRender = (payload) => {
  return { type: HANDLE_LOGIN_RENDER, payload};
};

export default reducer;
export {
  // Actions
  HANDLE_LOGIN_RENDER,
  HANDLE_LOGIN,
  HANDLE_OKTA_LOGIN,
  HANDLE_OKTA_LOGIN_FAIL,
  HANDLE_LOGIN_SUCCESS,
  HANDLE_LOGIN_FAIL,
  HANDLE_LOGIN_INPUT_CHANGE,
  HANDLE_LOGIN_FORGOT_CREDENTIALS,
  HANDLE_MODAL_CLOSE,

  // Action Creators
  handleLoginRender,
  handleLogin,
  handleOktaLogin,
  handleOktaLoginFailure,
  handleLoginSuccess,
  handleLoginFail,
  handleLoginInputChange,
  handleLoginForgotCredentials,
  handleModalClose
};
